enum PciDashboardProviderTerminationStatusEnum {
  NotTerminated = "NotTerminated",
  Terminated = "Terminated",
  UnprocessedTermination = "UnprocessedTermination"
}

export { PciDashboardProviderTerminationStatusEnum };